import { User } from 'models/user';
import { create } from 'zustand'

interface UserState {
    user: User | null
    can: (roles: string[]) => boolean,
    setUser: (user: User|null) => void,
}

export const useUser = create<UserState>()(
    (set, get) => ({
        user: null,
        can: (roles:string[]) => {
            const user = get().user;
            if (!user)
                return false;
            return user.roles?.some(r => roles.includes(r.name));
        },
        setUser: (user:User|null) => set((state) => ({user})),
    }),
)